/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_7_TitleInputs */

const et_portfolio_project_7_title = /** @type {(inputs: Portfolio_Project_7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-poe konversioonid kasvasid 40% konversioonipõhise ümberkujundusega.`)
};

const en_portfolio_project_7_title = /** @type {(inputs: Portfolio_Project_7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boosted eCommerce conversions by 40% with a conversion-first redesign.`)
};

/**
* | output |
* | --- |
* | "Boosted eCommerce conversions by 40% with a conversion-first redesign." |
*
* @param {Portfolio_Project_7_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_7_title = /** @type {((inputs?: Portfolio_Project_7_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_7_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_7_title(inputs)
	return en_portfolio_project_7_title(inputs)
});